import MarketplaceItemDataRow from './MarketplaceItemDataRow'

export default MarketplaceItemDataRow
